<template>
  <v-btn
    v-if="
      employee &&
        employee.id != (me && me.id) &&
        employee.started == '1970-01-01T00:00:00Z' &&
        role('admin', 'safetyRepresentative') &&
        employee.isActive
    "
    @click="disable"
    class="primary accent-4 white--text mr-2 my-1"
    small
  >
    <v-icon small left>
      warning
    </v-icon>
    {{ $t("profile.assignment.deactivate") }}
  </v-btn>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import SetEmployeeIsActiveQuery from "@/graphql/SetEmployeeIsActive.gql";

export default {
  props: ["employee"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["role"]),
    ...mapState(["me"]),
  },
  methods: {
    disable() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: SetEmployeeIsActiveQuery,
          variables: {
            id: this.employee.id,
            state: false,
          },
        })
        .then(() => {
          this.employee.isActive = false;
          this.$emit("refresh");
          this.$store.commit("push_global_message", {
            text: `${this.$i18n.t("import.employeeId")} ${
              this.employee.id
            } ${this.$i18n.t("import.inactive").toLowerCase()}`,
            color: "success",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
